<template>
  <v-content>
    <v-row>
      <v-col>

      <v-btn class="text-right" text @click="newRow">
      <v-icon>mdi-plus</v-icon>New Row</v-btn>
    </v-col>

      <v-col>
        <v-btn class="text-right" text @click="save"> <v-icon>mdi-check</v-icon>Save</v-btn>
      </v-col>
      <v-col>
        <v-btn class="text-right" text @click="build"> <v-icon>mdi-send</v-icon>Build</v-btn>
      </v-col>
      <v-col>
        <v-btn class="text-right" text @click="checkConnections"> <v-icon>mdi-check</v-icon>Check Connections</v-btn>
      </v-col>
      <v-col>
        <v-dialog v-model="scanDialog" persistent max-width="800">
           <template v-slot:activator="{ on, attrs }">
             <v-btn
               v-bind="attrs"
               v-on="on"
               text
             >
             <v-icon>mdi-magnify</v-icon>Scan
             </v-btn>
           </template>
           <v-card>
             <v-card-title class="headline">Scan Log</v-card-title>
             <v-card-text>Queue Size: {{ queue_size }}</v-card-text>
             <v-card-text>
               <!-- Console code -->

                  <div
                 class="console-entry"
                 v-html="socket_messages"
                 id="scanDiv"
               >

             </div>

             </v-card-text>
             <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="blue darken-1" text @click="scanDialog = false">Close</v-btn>
               <v-btn color="blue darken-1" text @click="initScan">Start Scan</v-btn>
             </v-card-actions>
           </v-card>
         </v-dialog>    
       </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            label="Search (Title)"
            outlined
            v-model="searchQuery"
            >
          </v-text-field>
        </v-col>
        <v-col>
      <v-select
            v-model="sheetName"
            :items="sheet_names"
            outlined
            v-on:change="changedSheet"

          ></v-select></v-col>
      </v-row>
  <v-expansion-panels multiple>
    <v-expansion-panel
      v-for="(row, index) in filteredSheet" :key="index" outlined
      expand
    >
    <template v-if="index >= startItem && index <= endItem">
      <v-expansion-panel-header  @click="showHeaderFunction(index)"  expand-icon="">
 <v-card class="elevation-0" v-if="showHeader[index]">
            <v-card-text >
              <v-row>
            <template v-for="market in allMarkets" >
                  <v-tooltip bottom :key="market">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="#50585f"
                      text
                      small
                      v-bind="attrs"
                      v-on="on"
                    >  <gb-flag :code=market size="small" :key="market" style="padding-right:10px;"/>    {{ sheet[filteredSheet[index].id][market].title }} </v-btn>



                  </template>
                  <span>{{ sheet[filteredSheet[index].id][market].url }}</span>

                    </v-tooltip>


            </template>

            </v-row>
                </v-card-text >

</v-card>

      </v-expansion-panel-header>
      <v-expansion-panel-content>
          <v-btn
                      color="#50585f"
                      text
                      small

                      @click="openDelSnackbar(filteredSheet[index].id)"
                    >    <v-icon> mdi-delete </v-icon> </v-btn>
         <v-row  v-for="market in allMarkets" :key="market">
                  <v-col>
                        <v-combobox
                          v-model="sheet[filteredSheet[index].id][market].title"
                          :items="gem_pages[market]"
                          clearable
                          @click:clear="onClearClicked(index,market)"
                          flat
                          dense
                          outlined
                          hide-no-data
                          hide-details
                          label="Title"
                          item-text="title"
                          item-value="title"
                          v-on:change="updateUrl(filteredSheet[index].id,market)"
                          :return-object="false"
                  >

                  </v-combobox>
                  </v-col>
                  <!-- <v-col> -->
                        <!-- <v-combobox
                          disabled
                          v-model="sheet[filteredSheet[index].id][market][3]"
                          cache-items
                          flat
                          hide-no-data
                          hide-details
                          label="URL"
                  ></v-combobox> -->

                  <!-- <v-text-field
                    :label="sheet[filteredSheet[index].id][market].url"
                    outlined
                    disabled
                  >  </v-text-field> -->
                  <!-- </v-col> -->
                  <v-col cols ="1">
                  <v-checkbox
                        v-model="sheet[filteredSheet[index].id][market].unique.status"
                        label="UA"
                        v-on:change="updateUnique(filteredSheet[index].id,market)"
                    ></v-checkbox>
                    </v-col>
                    <v-col cols="1.5" v-for="market1 in allMarkets" :key="market1"
                    v-if="sheet[filteredSheet[index].id][market1].unique.status"

                    >
                    <v-text-field
                      :label="market1"
                      outlined
                      :value = sheet[filteredSheet[index].id][market].unique[market1]
                        @change="value => sheet[filteredSheet[index].id][market].unique[market1] = value">
                    </v-text-field>
                    </v-col>
                </v-row>

      </v-expansion-panel-content>
      </template>
    </v-expansion-panel>
  </v-expansion-panels>
  <v-pagination
     v-model="page"
     :length="totalPages"
     circle
     @input="nextPage"
   ></v-pagination>
<!--
 <v-card v-for="(row, index) in sheet" :key="index" outlined>
            <v-card-text>

                <v-row  v-for="market in allMarkets" :key="market">
                                                 <gb-flag :code=market size="small" :key="market" />


                  <v-col>

                        <v-combobox
                          v-model="sheet[filteredSheet[index].id][market][2]"
                          :items="gem_sites"
                          cache-items
                          flat
                          hide-no-data
                          hide-details
                          label="Title"
                  ></v-combobox>
                  </v-col>
                  <v-col>
                        <v-combobox
                          v-model="sheet[filteredSheet[index].id][market][3]"
                          :items="gem_sites"
                          cache-items
                          flat
                          hide-no-data
                          hide-details
                          label="URL"
                  ></v-combobox>
                  </v-col>
                </v-row>
                </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

            </v-card-actions>
          </v-card> -->

   <v-snackbar
      v-model="snackbar"

      top
    >
      {{ snackbarMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>



    </v-snackbar>

           <v-snackbar
                                top
                                v-model="delSnackbar"
                              >

                                  <v-btn
                                    color="pink"
                                    text
                                    @click="delSnackbar = false"
                                  >
                                    Close
                                  </v-btn>
                                  <v-btn

                                        text
                                        @click="deleteRow()"
                                      >
                                        Yes
                                      </v-btn>
                              </v-snackbar>




</v-content>


</template>

<style>
.title1 {
  text-overflow: ellipsis;
white-space: nowrap;
overflow: hidden;
display: inline-block;
padding-right: 20px;
font-size: 14px !important;
}

  .console-entry {
                  height: 300px;
                  margin :0;
                  padding: 5px;
                  padding-top: 4px;
                  background-color: #46004F;
                  overflow-y:auto;
                        width: 100%;
                        color: white;
                        font-size: 13px;
                        font-family: 'Droid Sans Mono', monospace;
  }
  .console-entry:hover {
                        background-color: #5A0066;
  }
  .date {
                        color: #FF47DA;
  }

  .scan_info {
                        color: #00FAF6;
      }

.warn {
                        color: #F5AB00;
}

    .err {
                        color: #FA0000;
    }


.scan_log > .v-input__control > .v-input__slot > .v-text-field__slot
 {

  height: 500px;
}

</style>

<script>
import io from 'socket.io-client';

export default {
  data: function () {
    return {
      scanDialog: false,
      sheet: [],
      page: 1,
      queue_size: "0",
      searchQuery: "",
      totalPages: 1,
      startItem: 0,
      endItem: 19,
      itemsPerPage: 20,
      snackbar: false,
      delSnackbar: false,
      snackbarMessage: "",
      allMarkets: ["gb","se","fi","no","it","de","ca","jp","nl","es","th"],
      gem_sites: [],
      showHeader: [],
      page_data: {},
      gem_pages: {},
      target_site: [],
      sheetName: "sports",
      sheet_names: ["sports"],
      deleteIndex: "",
      socket_messages: "<span class='scan_info'>[INFO]</span> Awaiting Command...<br>",
    }
  },

  created: function(){
      var sheetName = this.sheetName
      if(sheetName == "sports"){
                this.allMarkets = ["es","ca","jp","ng","pl","fi","cr","br"]
      }
      else{
        this.allMarkets = ["jp","nl","es","de"]
      }
      this.$store.dispatch('getSheetData',{sheetName})
        .then( response => {
          // this.sheet = response.data
          var sheetData = response.data.sheet_data
          var index = 0;
          this.page_data = response.data.page_data
          for(var i =0;i<sheetData.length;i++){
            response.data.sheet_data[i].id = i

           for(var j=0; j<this.allMarkets.length;j++){
              var market = this.allMarkets[j]
	      console.log(market)
              if(!sheetData[i][market]){
                              // console.log(response.data.sheet_data[i][market].url)

                response.data.sheet_data[i][market] = {}
                response.data.sheet_data[i][market].unique = {}
                response.data.sheet_data[i][market].unique.status = false

              }
              // response.data.sheet_data[index][market].unique= {}
                // response.data.sheet_data[index][market].unique.status = false

            }
            this.showHeader.push(true)
            index++

          }

            this.sheet = response.data.sheet_data
            response.data.page_data.forEach( (row) => {

              this.gem_sites.push(row.website)
              this.gem_pages[row.market] = row.pages
            })
            this.totalPages = Math.ceil(this.sheet.length/this.itemsPerPage)
          }
        )
        .catch(err => {
          console.log(err)
        })

      //  this.$store.dispatch('getDomainList')
      //   .then( response => {
      //     //SUCCESS SNACKBAR
      //     for(var i=0; i<response.data.data.length; i++){
      //       this.backtrack_domains.push(response.data.data[i].domain)

      //     }
      //   }

      //   )
      //   .catch( () => {

      //   })

    },

    computed: {
      filteredSheet(){
        if(this.searchQuery == ""){
          return this.sheet
        }else{
          var allMarkets = this.allMarkets
          var arrayToRet = []
          var searchQuery = this.searchQuery
          this.sheet.forEach(function (obj) {
            var pushRow = false
            for(var i=0;i<allMarkets.length;i++){
              var market = allMarkets[i]
              if(typeof obj[market].title != "undefined" && obj[market].title != null){
                if(obj[market].title.toLowerCase().includes(searchQuery.toLowerCase()))
                {
                    pushRow = true
                }
              }
            }
            if(pushRow){
              arrayToRet.push(obj)
            }
          })
        return arrayToRet
        }
    }
  },
    methods: {

      nextPage(){
        var pageNo = this.page
        var itemsPerPage = this.itemsPerPage
        if(pageNo == 1){
          this.startItem = 0
          this.endItem = 19
        }else{
          this.startItem= (pageNo-1) * itemsPerPage
          this.endItem= pageNo * itemsPerPage
        }
       
      },

      checkConnections(){
          this.$store.dispatch('initCheckConnection')
          .then( response => {
            this.snackbarMessage = response.data.msg;
            this.snackbar = true

          })
          .catch( () => {

          })



      },
      initScan (){
        this.socket_messages= "<span class='scan_info'>[INFO]</span> Awaiting Command...<br>"

        this.$store.dispatch('initScan')
        .then( response => {
          console.log(response)
          // this.snackbarMessage = response.data;
          // this.snackbar = true
          // this.loading = false




        })
        .catch( () => {

        })

        const socket = io.connect('https://gem.vdot.cloud', {path: '/api/socket.io/'});
        var thiss = this
        socket.on('scan_progress', (message) => {
          // console.log(message)
          thiss.socket_messages += message
          var div = document.getElementById('scanDiv');
          div.scrollTo(0,div.scrollHeight);
        });
        socket.on('queueSize', (message) => {
          // console.log(message)
          thiss.queue_size = message
        });





     },
     updateUnique(index,market){
       var condition = this.sheet[index][market].unique.status
      this.$set(this.sheet[index][market].unique, 'status',condition )
      console.log(this.sheet[index][market])
     },
     openDelSnackbar(index) {
       this.deleteIndex = index
       this.delSnackbar = true
     },

     changedSheet(){
       var sheetName = this.sheetName
         if(sheetName == "New"){
                this.allMarkets = ["gb","se","fi","no","it","de","ca","nl","th","jp"]
      }else if(sheetName == "Pilot"){
                this.allMarkets = ["gb","se","fi","no","it","de","ca","jp"]

      }
      else{
        this.allMarkets = ["jp","nl","es","de","ca"]
      }
       this.$store.dispatch('getSheetData',{sheetName})
         .then( response => {
           this.gem_sites = []
           this.gem_pages = {}
           // this.sheet = response.data
           console.log(response.data.page_data)
           var index = 0;
           this.page_data = response.data.page_data
           console.log(response.data.sheet_data)
           response.data.sheet_data.forEach( (row) =>  {
             row.id=index
             for(var i =0; i<  this.allMarkets.length;i++){
               var market = this.allMarkets[i]
                if(!row[market]){
                  row[market] = {}
                  row[market].unique = {}
                  row[market].unique.status = false
                }
             }
             this.showHeader.push(true)
             index++
             })

             this.sheet = response.data.sheet_data

             response.data.page_data.forEach( (row) => {

              this.gem_sites.push(row.website)
              this.gem_pages[row.market] = row.pages

             })

             this.totalPages = Math.ceil(this.sheet.length/this.itemsPerPage)
             this.startItem = 0
             this.endItem = 20
             this.page = 1


           }
         )
         .catch(err => {
           console.log(err)
         })

     },
     deleteRow (){
       this.sheet.splice(this.deleteIndex,1)
       this.delSnackbar = false
    },
     newRow (){
       var currObj= {}
       currObj.id = this.sheet.length
       for(var i =0; i<this.allMarkets.length;i++){
         var market = this.allMarkets[i]
         currObj[market] = {}
         currObj[market].post_id = null
         currObj[market].website_id = null
         currObj[market].title = null
         currObj[market].url = null
         currObj[market].unique = {}
         currObj[market].unique.status = false
       }
       console.log(currObj)
       this.sheet.push(currObj)

       this.showHeader.push(true)
       this.totalPages = Math.ceil(this.sheet.length/this.itemsPerPage)


    },

     showHeaderFunction (index){
       var condition = !this.showHeader[index]
       this.showHeader.splice(index, 1,condition);

     },
     updateUrl(index,market){
       var getTitle = this.sheet[index][market].title
       console.log(getTitle)
       let obj = this.gem_pages[market].find(obj => obj.title == this.sheet[index][market].title);
       console.log(obj)
       if(obj){
          this.sheet[index][market].website_id = obj.website_id
          this.sheet[index][market].post_id = obj.post_id
          this.sheet[index][market].url = obj.url
       }else{
         this.sheet[index][market] = {}
          this.sheet[index][market].unique = {}
       }
       console.log(this.sheet[index])

     },

     onClearClicked(index,market){
          this.sheet[index][market] = {}
          this.sheet[index][market].unique = {}
     },
     save (){
        var sheet = this.sheet
        var sheetName = this.sheetName
        console.log()
        console.log(sheet)
        this.$store.dispatch('saveSheet',{sheet,sheetName})
        .then( response => {
          console.log(response)
          this.snackbarMessage = "Sheet data was saved successfully!";
          this.snackbar = true

        })
        .catch( () => {


        })


     },
        build (){
        var sheet = this.sheet
        var sheetName = this.sheetName
        console.log()
        this.$store.dispatch('build',{sheetName})
        .then( response => {
          console.log(response)
          this.snackbarMessage = "Build Sent successfully to niche: " + sheetName;
          this.snackbar = true

        })
        .catch( () => {


        })


     },
       edit (){
        this.snackbarMessage = "Scan started Successfully"
        this.snackbar = true
        this.loading = true
        this.$store.dispatch('initScan')
        .then( response => {
          console.log(response)
          this.snackbarMessage = response.data;
          this.snackbar = true
          this.loading = false

        })
        .catch( () => {


        })


     },

  },

  metaInfo () {
    return {
      title: 'BackTrack | Dashboard'
    }
  }
}
</script>
